import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { CompanyListItems, ICompanyListItems } from "./companyListItems";

export interface ICompanyPageList {
    companyGroups: IIdTitle[];
    list: ICompanyListItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class CompanyPageList implements ICompanyPageList {
    companyGroups: IdTitle[];
    list: CompanyListItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: ICompanyPageList);
    constructor(obj?: any) {
        this.list = new CompanyListItems(obj && obj.list || null);
        this.companyGroups = Base.getTypedArray(obj ? obj.companyGroups : null, IdTitle);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
    }
}